// Badge numbers follow the scenario type: a cash scenario has no Loan Costs card, so the left column
// renumbers from 1 (spec scenarios-cash-spec.28.09.md §4.1, K5). Anything but 'loan' is cash, the
// same test every other scenarioType gate on this screen makes.
const CASH_NUMBERS = { acquisition: 1, holding: 2, selling: 3 }
const LOAN_NUMBERS = { loan: 1, acquisition: 2, holding: 3, selling: 4 }

export function isLoanScenario(scenarioType) {
  return scenarioType === 'loan'
}

export function sectionNumber(scenarioType, section) {
  return (isLoanScenario(scenarioType) ? LOAN_NUMBERS : CASH_NUMBERS)[section]
}
